import axios from 'axios'

// Shared base URL for all API calls (services + legacy axios usage)
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000'
const API_TIMEOUT = parseInt(import.meta.env.VITE_API_TIMEOUT) || 120000

// Ensure the default axios instance also uses VITE_API_BASE_URL
axios.defaults.baseURL = API_BASE_URL

// Create axios instance for services/composables
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: API_TIMEOUT,
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  }
})

// Shared request interceptor: attach JWT token to every request
const onRequest = (config) => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
}

// Shared response error interceptor: handle 401
const onResponseError = (error) => {
  if (error.response?.status === 401) {
    // Debug: log 401 in DevTools Console (enable Preserve log on Network tab)
    
     localStorage.removeItem('token')
    localStorage.removeItem('user')
    window.location.href = '/login'
  }
  return Promise.reject(error)
}

// Attach interceptors to the dedicated api instance (services use this)
api.interceptors.request.use(onRequest, (error) => Promise.reject(error))
api.interceptors.response.use(
  (response) => (response.config?.returnFullResponse ? response : response.data),
  onResponseError
)

// Also attach auth header + 401 handling to the default axios instance
// so legacy code that imports axios directly also gets the Authorization header.
axios.interceptors.request.use(onRequest, (error) => Promise.reject(error))
axios.interceptors.response.use(
  (response) => response,
  onResponseError
)

// Make api available globally (optional, for components using window.axios)
window.axios = api

export default api
